<template lang="pug">
.content-download-container
  el-header(v-if='!percentDone', height='40px') {{ modificationsAll.length }} {{$t('desktops can be synchronized:')}}
  el-form(:inline="true")
    el-form-item
      el-input(id="UpdateContentProgressReportList-searchInput", v-model='searchByName', style='width: 300px; margin-left: 0px;', clearable, size="mini", prefix-icon="el-icon-search", :placeholder='$t("Screen")')
    el-form-item(:label="$t('Start at')")
      el-date-picker(v-model="delayed", type="datetime", :placeholder='$t("Delayed")', id='delayedTimePicker', size='mini')
    el-form-item()
      el-button-group
        el-button(id="UpdateContentToStartReportList-syncMineButton", v-if="modificationsAll.length > 1 && !hideSynchroAllButton", type="success", size="mini", @click="hideSynchroAllButton = true; sendAllContentUpdateRequests(true)")
          font-awesome-icon(icon="upload")
          span &nbsp; {{$t('Synchronize mine')}}
        el-button(id="UpdateContentToStartReportList-syncAllButton", v-if="modificationsAll.length > 1 && !hideSynchroAllButton", type="success", size="mini", @click="hideSynchroAllButton = true; sendAllContentUpdateRequests()")
          font-awesome-icon(icon="upload")
          span &nbsp; {{$t('Synchronize all')}}
  hr.header
  el-header.spinner-container(v-if='percentDone')
    el-progress(:text-inside='true', :stroke-width='15', :percentage='percentDone', status='success')
    hr.header
  .content-download-row(v-for="modification in modificationsFiltered", :key="modification.id")
    .cell.device
      span {{ fullNameOfDesktopPlaylist(modification.Medium) }}
    .cell.user
      span
        font-awesome-icon.user-icon(
          :class='{ active: modification.User.id === $store.state.User.user.id }',
          icon="user"
        )
        | &nbsp; {{ getUserDisplayName(modification.User.id) }}

    .cell.time
      span {{ humanTime(modification.updatedAt) }}
    .cell.delete-button.float-right
      el-button(
        :id="'UpdateContentToStartReportList-syncModification'+modification.id",
        type="success",
        size="mini",
        @click="sendContentUpdateRequest(modification)",
        :title="$t('Start content download')",
      )
        font-awesome-icon(icon="upload")
  br
</template>

<script>
import Vue from 'vue'
import textUtilsMixin from '../Common/textUtils.mixin'

export default {
  mixins: [textUtilsMixin],
  props: ['side'],
  async created () {
    this.modificationsAll = await this.$store.dispatch('Device/getDeviceDesktopsAffected')
    this.modificationsFiltered = this.modificationsAll
  },
  data () {
    return {
      errors: {
      },
      hideSynchroAllButton: false,
      percentDone: undefined,
      searchByName: '',
      modificationsAll: [],
      modificationsFiltered: [],
      delayed: null
    }
  },
  watch: {
    searchByName: async function (newVal, oldVal) {
      this.modificationsFiltered = this.modificationsAll.filter((modification) => {
        return this.fullNameOfDesktopPlaylist(modification.Medium).toLowerCase().indexOf(newVal.toLowerCase()) > -1
      })
    }
  },
  methods: {
    async sendContentUpdateRequest (modification) {
      await Vue.axios.post('devicedesktop/prepareContentsAndSendRequestToDevice', { 'ModificationId': modification.id, delayed: this.delayed })
      if (this.modificationsFiltered.length === 0) this.$emit('finished')
    },
    async sendAllContentUpdateRequests (byMe) {
      this.percentDone = 0
      const toBeDone = byMe ? this.modificationsFiltered.filter(m => m.User.id === this.$store.state.User.user.id).length : this.modificationsFiltered.length
      let done = 0
      for (const modification of JSON.parse(JSON.stringify(this.modificationsFiltered))) {
        if (byMe) {
          if (modification.User.id === this.$store.state.User.user.id) {
            await this.sendContentUpdateRequest(modification)
          }
        } else {
          await this.sendContentUpdateRequest(modification)
        }
        done++
        this.percentDone = parseInt((done / toBeDone) * 100, 10)
      }
      this.percentDone = 100
      this.hideSynchroAllButton = false
    },
    getDeviceName (deviceId) {
      return this.$store.state.Device.device_list.find(device => device.id === deviceId).name
    },
    getUserDisplayName (userId) {
      const author = this.$store.state.User.user_list_network.find(user => user.id === userId)
      return author ? author.nick : this.$t('Administrator as guest')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .content-download-row {
    display: flex;
    font-size: $--font-size-base;
    align-items: center;
    border-bottom: $--border-light;
    padding: 10px 0px;
    .cell {
      &:first-child {
        padding-left: 0px;
      }
      padding: 0px 20px;
      overflow: hidden;
      user-select: none;
      .user-icon {
        opacity: 0;
        &.active {
          opacity: 1;
        }
      }
    }
    .device {
      width:40%;
    }
    .user {
      width:20%;
    }
    .time {
      width:30%;
    }
    .delete-button {
      width:10%;
      text-align: right;
      padding-right: 0px;
    }
  }
  .spinner-container {
    text-align: center;
    .spinner {
      width: 70px;
      height: 70px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Device/UpdateContentToStartReportList.vue